import { useTranslation } from "react-i18next";
import { Shield, Lock, Server, Award } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";
import { SecurityShieldIllustration } from "./BlueprintIllustrations";

const badges = [
  { icon: Shield, titleKey: "landing.trust.gdpr.title", descKey: "landing.trust.gdpr.description" },
  {
    icon: Lock,
    titleKey: "landing.trust.encryption.title",
    descKey: "landing.trust.encryption.description",
  },
  {
    icon: Server,
    titleKey: "landing.trust.hosting.title",
    descKey: "landing.trust.hosting.description",
  },
  { icon: Award, titleKey: "landing.trust.sso.title", descKey: "landing.trust.sso.description" },
];

export function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-6">
        <ScrollReveal>
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
              {t("landing.trust.title")}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t("landing.trust.subtitle")}
            </p>
            {/* Blueprint-Sicherheitsschild (DS-v2, TES-1086 — ersetzt Stock-Clipart) */}
            <div className="flex justify-center pt-4">
              <SecurityShieldIllustration
                title={t("landing.trust.illustrationAlt")}
                className="w-40 h-40 drop-shadow-lg"
                data-testid="trust-illustration"
              />
            </div>
          </div>
        </ScrollReveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {badges.map((b, i) => (
            <ScrollReveal key={b.titleKey} delay={i * 100}>
              <div className="group text-center space-y-4 p-6 rounded-2xl bg-card/50 border border-border/30 landing-hover-glow transition-colors duration-300">
                <div className="w-14 h-14 mx-auto rounded-full bg-brand-container text-brand-container-foreground flex items-center justify-center">
                  <b.icon className="h-7 w-7 landing-rotate-shield" />
                </div>
                <h3 className="font-semibold text-foreground">{t(b.titleKey)}</h3>
                <p className="text-sm text-muted-foreground">{t(b.descKey)}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
